import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { filterProduct } from "../../redux/features/search/searchSlice";
const CategoryCard = ({ title, icon, description, url, value }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const clickHandler = () => {
    dispatch(filterProduct(value));

    navigate("/products");
  };
  return (
    <button onClick={clickHandler}>
      <div className="flex flex-col items-center justify-center border border-slate-200  p-5 bg-white shadow-sm  hover:shadow-xl transition-all duration-200 ">
        {icon}
        <h1 className=" pt-2 text-xl font-extrabold text-black">{title}</h1>
        <p className=" text-slate-800 text-sm pt-5">{description}</p>
      </div>
    </button>
  );
};

export default CategoryCard;
